// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGenerateAssistedMessageRequestPayload,
  TGenerateAssistedMessageResponsePayload,
} from './llm.types.ts';

export const createLlmApi = (transport: TApiTransport) => ({
  /** Generates an AI-assisted reply draft */
  generateAssistedMessage: (
    payload: TGenerateAssistedMessageRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGenerateAssistedMessageRequestPayload,
      TGenerateAssistedMessageResponsePayload
    >('/generate_assisted_message', payload, options),
});
